import React, { useState, useRef, useEffect } from "react";
// import ApmHeader from "../../template/ApmHeader";
import ApmFooter from "../../template/ApmFooter";
import useDataRequesting from "../hooks/useDataRequesting";
// import useDataFetching from "../hooks/useDataFetching";
import ReactPlayer from "react-player";
import "./screen-control.css";
// import socketIOClient from "socket.io-client";
import apiService from "../../apiService";
import usePuskesmas from "../hooks/usePuskesmas";
// import { set } from "date-fns";

const ScreenControl = ({ puskesmas, socket }) => {
  const [registrationQueue, setRegistrationQueue] = useState("");
  const [clinicQueue, setClinicQueue] = useState("");
  const [notification, setNotification] = useState("");
  const [queueData, setQueueData] = useState("");
  const [callQueues, setCallQueues] = useState([]);
  const [isAudioPlay, setIsAudioPlay] = useState(false);
  const [isAudioEnded, setIsAudioEnded] = useState(false);
  const [queueNumber, setQueueNumber] = useState(0);
  const [listVideo, setListVideo] = useState([]);
  const [video, setVideo] = useState();
  const [Volume, setVolume] = useState('1');


  const {
    results: registrationResults,
    loading: registrationLoading,
    error: registrationError,
    setRequest: setRegisterRequest,
  } = useDataRequesting();

  const {
    results: clinicResults,
    loading: clinicLoading,
    error: clinicError,
    setRequest: setClinicRequest,
  } = useDataRequesting();

  const audioRef = useRef();
  const playRef = useRef();

  const dataFetching = async () => {
    const response1 = await apiService.get(
      `/apm/clinics/apm/${puskesmas.code}/1/0`
    );
    setRegistrationQueue(response1.data);
    // const response2 = await apiService.get(
    //   `/apm/clinics/read/${puskesmas.code}/2/0`
    // );
    const response2 = await apiService.get(
      `/apm/clinics/apm/${puskesmas.code}/2/0`
    );
    if (response2.code === 200) {
      setClinicQueue(response2.data);
    }
  };

  const updateQueue = ({ type, clinicId, currentQueue }) => {
    switch (type) {
      case "registration":
        setRegistrationQueue((prevStates) => {
          return prevStates.map((prevState) => {
            if (prevState.clinic_id !== clinicId) return prevState;
            if (!prevState.call)
              return { ...prevState, call: { queue: currentQueue } };
            prevState.call.queue = currentQueue;
            return prevState;
          });
        });
      case "clinic":
        let code = currentQueue.substring(0, 1);
        setClinicQueue((prevStates) => {
          return prevStates.map((prevState) => {
            if (prevState.queue_clinic_code !== code) return prevState;
            if (!prevState.call)
              return { ...prevState, call: { queue: currentQueue } };
            prevState.call.queue = currentQueue;
            return prevState;
          });
        });
      default:
        break;
    }
  };

  const call = (
    audioRefParam,
    { currentQueue, clinicName = "pendaftaran" }
  ) => {
    setNotification({ queue: currentQueue, place: clinicName });
    // audioRefParam.current.src = `http://smartsisfomas.simkes.id:1235/apm/antrian/${ currentQueue }`;
    // audioRefParam.current.play();
  };

  const getDuration = (e) => {
    setQueueData({ ...queueData, duration: e.target.duration });
  };

  const checkIsAudioPlay = () => {
    if (playRef.current.played.length >= 1) return false;
  };

  const checkCallQueues = () => {
    if (callQueues.length > 1) return "";
    setIsAudioPlay(true);
  };

  useEffect(() => {
    dataFetching();
    socket.on("updateCurrentQueue", (data) => updateQueue(data));
    socket.on("playMessage", () => { });
    // socket.on('getDuration', ({ currentQueue, clinicName }) => {
    //   audioRef.current.src = `http://smartsisfomas.simkes.id:1235/apm/antrian/${ currentQueue }`;
    //   setQueueData({ currentQueue, clinicName });
    // });
    socket.on("playAudio", ({ currentQueue, clinicName, room = '' }) => {
      setCallQueues((prevState) => {
        prevState.push({ currentQueue, clinicName, room });
        return [...prevState];
      });
    });
  }, []);

  useEffect(() => {
    if (callQueues.length) checkCallQueues();
  }, [callQueues]);

  // useEffect(() => {
  //   if (queueData.duration) {
  //     socket.emit('gotDuration', {
  //       duration: queueData.duration,
  //       currentQueue: queueData.currentQueue,
  //       clinicName: queueData.clinicName
  //     });
  //   }
  // }, [ queueData ]);

  useEffect(() => {
    const baseUrl = apiService.service.defaults.baseURL;
    if (isAudioPlay) {
      setVolume('0.4');
      if (callQueues[queueNumber]) {
        setNotification({
          queue: callQueues[queueNumber].currentQueue,
          place: callQueues[queueNumber].clinicName,
        });
        // playRef.current.src = `${baseUrl}/apm/antrian/${callQueues[queueNumber].currentQueue}/${puskesmas.code}``${callQueues[queueNumber].room ? '/'.callQueues[queueNumber].room :''}`;
        if(callQueues[queueNumber].room){
        playRef.current.src = `${baseUrl}/apm/antrian/${callQueues[queueNumber].currentQueue}/${puskesmas.code}/${callQueues[queueNumber].room}`;
        } else {
        playRef.current.src = `${baseUrl}/apm/antrian/${callQueues[queueNumber].currentQueue}/${puskesmas.code}`;
        }

        var playPromise = playRef.current.play();

        if (playPromise !== undefined) {
          playPromise
            .then((_) => {
              // Automatic playback started!
              // Show playing UI.
            })
            .catch((error) => {
              // Auto-play was prevented
              // Show paused UI.
              // playRef.current.play();
              setIsAudioEnded(true);

            });
        }
      } else {
        setCallQueues([]);
        setQueueNumber(0);
      }
      setIsAudioPlay(false);
    } else {
      setVolume('1');
    }
  }, [isAudioPlay, queueNumber, callQueues]);

  useEffect(() => {
    if (isAudioEnded) {
      setQueueNumber((prevState) => prevState + 1);
      setIsAudioPlay(true);
      setIsAudioEnded(false);
    }
  }, [isAudioEnded]);

  const getRefVideo = async () => {
    const response2 = await apiService.get(
      `/management/videos/read`
    );
    if (response2.code == 200) {
      let x = []
      response2.data.map((a, b) => {
        x.push(a.url)
      })
      setListVideo(x)
      setVideo(x[0])
    } else {
      setListVideo([])
      setVideo('')

    }
  }
  useEffect(() => {
    getRefVideo();
  }, [listVideo.length])
  const getVideo = (e) => {
    let vid = listVideo.findIndex((el) => el === video);
    if (vid >= 0) {
      if (vid + 1 !== listVideo.length) {
        setVideo(listVideo[vid + 1]);
      } else {
        // console.log("x");
        setVideo(listVideo[0]);
      }
    } else {
      setVideo(listVideo[0]);
    }
  };

  const clinics = clinicQueue ? clinicQueue : [];
  const registrations = registrationQueue ? registrationQueue : [];
  const { queue = "", place = "" } = notification;
  return (
    <div>
      <audio ref={audioRef} onLoadedData={getDuration} />
      <audio
        ref={playRef}
        // onPlay={ () => setIsAudioPlay(true) }
        onEnded={() => setIsAudioEnded(true)}
      />
      <div className="container-fluid">
        <div className="row mt-5">
          <div className="col-8">
            <ReactPlayer
              url={video}
              playing={true}
              controls={false}
              width="100%"
              volume={Volume}
              onEnded={() => getVideo()}
            />
          </div>
          <div className="col-4">
            <div className="card">
              <div className={"card-header bg-white"}>
                <h1 className={"text-center"} style={{ fontSize: "40px" }}>
                  NOMOR ANTRIAN
                </h1>
              </div>
              <div className={"card-body bg-warning"}>
                <div>
                  <h1 className="text-center" style={{ fontSize: "80px" }}>
                    <font className="text-yellow">{queue.slice(0, 1)}</font>
                    <font className="text-white">
                      {queue ? queue.slice(1, 4) : "000"}
                    </font>
                  </h1>
                  <h1
                    className="text-center display-1 text-white blinking"
                    style={{ fontSize: "50px" }}
                  >
                    {notification ? (
                      <>
                        <i className="fas fa-angle-double-right mr-2"></i>
                        <font>{place.toUpperCase() || ""}</font>
                      </>
                    ) : (
                      ""
                    )}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          {clinics
            .filter((clinic) => clinic.active && clinic.queue)
            .map((clinic) => (
              <Queue data={clinic} group="clinic" key={clinic.id} />
            ))}
          {registrations
            .filter((clinic) => clinic.active && clinic.queue)
            .map((registration) => (
              <Queue
                data={registration}
                group="registration"
                key={registration.id}
              />
            ))}
        </div>
      </div>
      <ApmFooter />
    </div>
  );
};

const Queue = ({ data, group }) => {
  // console.log(data);
  const [maxx, setMaxx] = useState(0);
  const getColor = (groupParam) => {
    switch (groupParam) {
      case "clinic":
        return "success";
        break;
      case "registration":
        return "info";
        break;
      default:
        break;
    }
  };
  const getMax = async () => {
    const mx = await apiService.get1(
      `/apm/queues/last/${data.puskesmas_id}/${data.clinic.id}`
    );
    if (mx.code) {
      setMaxx(mx.data.queue);
    } else {
      setMaxx(mx.data.data.queue);
    }
  };
  useEffect(() => {
    const x = getMax();
  }, [data?.call]);

  const { clinic, call, queue_clinic_code } = data || [];
  const currentQueue = call ? call.queue.toUpperCase().slice(1) : "000";
  const max = maxx ? maxx : "A001";
  const maxvalue = parseInt(max ? max.toUpperCase().slice(1) : "000");
  const diff =
    maxvalue - parseInt(currentQueue) > 0
      ? maxvalue - parseInt(currentQueue) - 1
      : 0;
  const cardHeaderColor = getColor(group);
  // console.log(max, maxx);
  return (
    <div className="col-2">
      <div className="card">
        <div className={"card-header py-2 bg-white"}>
          <h1
            style={{ fontSize: "30px" }}
            className={`text-center text-black`}
          >
            {clinic.name.toUpperCase()}
          </h1>
        </div>
        <div className={`card-body bg-${cardHeaderColor}`}>
          <div>
            <h1 className="text-center display-2" style={{ fontSize: "100px" }}>
              <font className="text-black">{queue_clinic_code}</font>
              <font className="text-white">{currentQueue}</font>
            </h1>
          </div>
        </div>
        <div className="card-footer">
          <div className="row">
            <div className="col-md-6">
              <h5>Sisa Antrian</h5>
            </div>
            <div className="col-md-6">
              <h3>
                {diff} dari {maxvalue - 1}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default usePuskesmas(ScreenControl);
